import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { 
  getContestCommnets as getContestCommnetsApi,
  saveContestCommnets as saveContestCommnetsApi
 } from "../../helpers/custom_helper/backend_helper"

export const getContestCommentsThunk = createAsyncThunk( "get-contest-comments",async (data, { rejectWithValue }) => {
    try {
      const response = await getContestCommnetsApi(data);

      if (response.success) {
        return response;
      } else {
        toast.error(response.message || "Data failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
 
      toast.error(error || "Something went wrong");
      return rejectWithValue(error);
    }
  }
);

export const saveContestCommentsThunk = createAsyncThunk( "save-contest-comments",async (data, { rejectWithValue }) => {
    try {
      const response = await saveContestCommnetsApi(data);
     
      if (response.success) {
        return response;
      } else {
        toast.error(response.message || "Data failed");
        return rejectWithValue(response.message);
      }
    } catch (error) {
 
      toast.error(error || "Something went wrong");
      return rejectWithValue(error);
    }
  }
);






